import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { TruckForm } from "@/features/dashboard/caminhoes/components/TruckForm";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes/modelos/cadastrar/modal")({
  component: () => (
    <BaseEditCreateModal title="Criar novo Modelo de Caminhão" from="/dashboard/caminhoes/modelos/cadastrar">
      <TruckForm />
    </BaseEditCreateModal>
  )
});
